var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolaioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 42.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.53524 21.839h22.671v7.0848h-22.671zm.70848 6.3763h21.254v-5.6679h-21.254z",
    fill: "#008768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.6201 20.604h8.5018v-10.101h-8.5018z",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10,
    strokeWidth: 0.70848
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.70848 0 0 .70848 9.2218 16.341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v16.883",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.70848 0 0 .70848 14.519 16.341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v16.883",
    fill: "none",
    stroke: "#008768",
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolaioIcon);
export default __webpack_public_path__ + "static/media/SolaioIcon.110f501cfc288f8281efb83eeec4aa25.svg";
export { ForwardRef as ReactComponent };